const ISV2_KEY = "isV2";

export function getIsV2(): boolean {
    const value = sessionStorage.getItem(ISV2_KEY);
    return value === null ? true : value === "true";
}

export function setIsV2(value: boolean) {
  sessionStorage.setItem(ISV2_KEY, value ? "true" : "false");
  try {
    window.dispatchEvent(new Event('isV2Change'));
  } catch (e) {
    // do nothing
  }
}